import React from 'react';
import { get } from 'lodash';

//local
import { CSrOrderListNotesWorkFlowLogService } from 'services/cSROrderListNotesWorkFlowLog';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

// React view component to render
import { cSrOrderListNotesWorkFlowLog as CSrOrderListNotesWorkFlowLogView } from 'ui/views/widgets/cSROrderListNotesWorkFlowLog';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { CsrOrderListNotesWorkFlowLog } from 'ui/containers/CSROrderListNotesWorkFlowLog';
 *
 * // render
 * <CsrOrderListNotesWorkFlowLog propName='propValue'/>
 */
export class CsrOrderListNotesWorkFlowLog extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
  
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        this.cSrOrderListNotesWorkFlowLogService = new CSrOrderListNotesWorkFlowLogService();

        this.fetchComponentData();

    }

    async fetchComponentData() {
        log.debug( 'CsrOrderListNotesLineItem.fetchComponentData()' );

        // cancel ongoing request
        this.cSrOrderListNotesWorkFlowLogService.cancel();

        try {
            const { status, data }  = await this.cSrOrderListNotesWorkFlowLogService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <CSrOrderListNotesWorkFlowLogView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                onCancelClick={ this.props.onCancelClick }
            />
        );
    }
}

// set display name
CsrOrderListNotesWorkFlowLog.displayName = 'CsrOrderListNotesWorkFlowLog';

// set default props
CsrOrderListNotesWorkFlowLog.defaultProps = {};

// prop types
CsrOrderListNotesWorkFlowLog.propTypes = {};
